export function getValueForStep(values, stepId, attrib = 'label') {
  const record = values.find(x => x.stepId === stepId);
  if (!record) {
    return null;
  }
  return record.value[attrib];
}
